(function () {
  const BUNDLE_HANDLE = 'tinte-capilar-instantaneo';
  const root = document.querySelector('[data-ds-drawer]');
  if (!root) return;

  const bodyEl = root.querySelector('[data-ds-drawer-body]');
  const pricingEl = document.querySelector('[data-ds-pricing]');
  let pricing = { compareUnit: 59999, tiers: [], unitAboveMax: 41666 };
  try {
    if (pricingEl) pricing = JSON.parse(pricingEl.textContent);
  } catch (_) {}

  function formatArs(n) {
    const s = String(Math.round(Number(n) || 0));
    return '$' + s.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }

  function marketingTotal(qty) {
    const q = Math.max(0, Number(qty) || 0);
    if (q <= 0) return 0;
    const tier = (pricing.tiers || []).find((t) => t.qty === q);
    if (tier) return tier.total;
    return q * (pricing.unitAboveMax || 41666);
  }

  function marketingCompare(qty) {
    return Math.max(0, Number(qty) || 0) * (pricing.compareUnit || 59999);
  }

  function openDrawer() {
    root.classList.add('is-open');
    root.setAttribute('aria-hidden', 'false');
    document.body.classList.add('ds-drawer-open');
  }

  function closeDrawer() {
    root.classList.remove('is-open');
    root.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('ds-drawer-open');
  }

  window.HairplusCart = {
    open: openDrawer,
    close: closeDrawer,
    refresh: refreshFromCart,
  };

  root.querySelectorAll('[data-ds-drawer-close]').forEach((el) => {
    el.addEventListener('click', closeDrawer);
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && root.classList.contains('is-open')) closeDrawer();
  });

  document.addEventListener('click', (e) => {
    const openBtn = e.target.closest('[data-ds-open-cart]');
    if (openBtn) {
      e.preventDefault();
      openDrawer();
      refreshFromCart();
    }
  });

  async function fetchCart() {
    const res = await fetch('/cart.js', { credentials: 'same-origin' });
    if (!res.ok) throw new Error('cart fetch failed');
    return res.json();
  }

  async function changeLine(key, quantity) {
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity }),
    });
    if (!res.ok) throw new Error('cart change failed');
    return res.json();
  }

  function emptyHtml() {
    return (
      '<div class="ds-cart ds-cart--empty" data-ds-cart data-empty="true">' +
      '<p class="ds-cart__empty">Tu carrito está vacío.</p>' +
      '<a href="/products/tinte-capilar-instantaneo#hairplus-bundle" class="ds-cart__empty-cta" data-ds-drawer-close>Ver producto</a>' +
      '</div>'
    );
  }

  function lineHtml(item, rowTotal, isBundle) {
    const img = item.image
      ? `<img src="${item.image}" alt="" width="72" height="72" loading="lazy" class="ds-cart__img">`
      : '';
    const variant =
      item.variant_title && item.variant_title !== 'Default Title'
        ? `<p class="ds-cart__meta">${escapeHtml(item.variant_title)}</p>`
        : '';
    const stepper = isBundle
      ? `${variant}<div class="ds-cart__stepper">
          <button type="button" class="ds-cart__step-btn" data-ds-qty-down aria-label="Quitar unidad">−</button>
          <span class="ds-cart__qty" data-ds-qty-value>${item.quantity}</span>
          <button type="button" class="ds-cart__step-btn" data-ds-qty-up aria-label="Agregar unidad">+</button>
        </div>`
      : `${variant}<p class="ds-cart__meta">× ${item.quantity}</p>`;
    const price = isBundle
      ? formatArs(rowTotal)
      : formatArs((item.final_line_price || 0) / 100);

    return `<div class="ds-cart__row" data-ds-line data-variant-id="${item.variant_id}" data-line-key="${item.key}" data-line-qty="${item.quantity}" data-is-bundle="${isBundle}">
      <div class="ds-cart__media">${img}</div>
      <div class="ds-cart__info">
        <div class="ds-cart__name">${escapeHtml(item.product_title || item.title || '')}</div>
        ${stepper}
      </div>
      <div class="ds-cart__end">
        <span class="ds-cart__price" data-ds-line-price>${price}</span>
        <button type="button" class="ds-cart__remove" data-ds-remove aria-label="Quitar">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M18 6 6 18M6 6l12 12"/></svg>
        </button>
      </div>
    </div>`;
  }

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function renderCart(cart) {
    const items = cart.items || [];
    if (!items.length) {
      bodyEl.innerHTML = emptyHtml();
      bodyEl.querySelectorAll('[data-ds-drawer-close]').forEach((el) => {
        el.addEventListener('click', closeDrawer);
      });
      updateBadge(0);
      return;
    }

    function isBundleItem(item) {
      const handle = item.handle || '';
      return (
        handle === BUNDLE_HANDLE ||
        (item.url && String(item.url).indexOf('/products/' + BUNDLE_HANDLE) !== -1) ||
        (item.properties && item.properties._hairplus_bundle === '1')
      );
    }

    let bundleCount = 0;
    let otherTotal = 0;
    items.forEach((item) => {
      if (isBundleItem(item)) bundleCount += item.quantity;
      else otherTotal += (item.final_line_price || 0) / 100;
    });
    const bundleTotal = marketingTotal(bundleCount);
    const bundleShopifySubtotal = marketingCompare(bundleCount);
    const bundleDiscount = Math.max(0, bundleShopifySubtotal - bundleTotal);
    const displayTotal = bundleTotal + otherTotal;
    const compare = marketingCompare(bundleCount);

    let lines = '';
    items.forEach((item) => {
      const isBundle = isBundleItem(item);
      lines += lineHtml(item, isBundle ? bundleTotal : 0, isBundle);
    });

    const compareHtml =
      compare > bundleTotal
        ? `<span class="ds-cart__compare" data-ds-cart-compare>${formatArs(compare + otherTotal)}</span>`
        : `<span class="ds-cart__compare" data-ds-cart-compare hidden></span>`;

    const perkShield =
      '<svg class="ds-cart__perk-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><path d="m9 12 2 2 4-4"/></svg>';
    const perkTruck =
      '<svg class="ds-cart__perk-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2"/><path d="M15 18H9"/><path d="M19 18h2a1 1 0 0 0 1-1v-3.65a1 1 0 0 0-.22-.624l-3.48-4.35A1 1 0 0 0 17.52 8H14"/><circle cx="17" cy="18" r="2"/><circle cx="7" cy="18" r="2"/></svg>';

    const discountNoteHtml =
      bundleDiscount > 0
        ? `<p class="ds-cart__discount-note ds-cart__discount-note--applied">Descuento bundle (se aplica en el checkout): −${formatArs(bundleDiscount)}</p>`
        : '';

    bodyEl.innerHTML = `<div class="ds-cart" data-ds-cart data-product-handle="${BUNDLE_HANDLE}" data-bundle-count="${bundleCount}">
      <div class="ds-cart__lines" data-ds-cart-lines>${lines}</div>
      <aside class="ds-cart__checkout" aria-label="Resumen del carrito">
        <details class="ds-cart__discount">
          <summary class="ds-cart__discount-row">
            <span>Descuento</span>
            <span class="ds-cart__discount-toggle" aria-hidden="true">+</span>
          </summary>
          <p class="ds-cart__discount-note">Podés aplicar tu código en la página de pago.</p>
        </details>
        <div class="ds-cart__total-row">
          <span class="ds-cart__total-label">Total estimado</span>
          <div class="ds-cart__total-prices">
            <span class="ds-cart__total" data-ds-cart-total>${formatArs(displayTotal)}</span>
            ${compareHtml}
          </div>
        </div>
        ${discountNoteHtml}
        <button type="button" class="ds-cart__checkout-btn" data-ds-checkout>Finalizar compra</button>
        <ul class="ds-cart__perks" role="note">
          <li class="ds-cart__perk">${perkShield}<span>3 Cuotas sin interés</span></li>
          <li class="ds-cart__perk">${perkTruck}<span>Envío gratis</span></li>
        </ul>
      </aside>
    </div>`;

    bindCartEvents();
    updateBadge(cart.item_count || 0);
  }

  function bindCartEvents() {
    bodyEl.querySelectorAll('[data-ds-qty-up]').forEach((btn) => {
      btn.addEventListener('click', async () => {
        const row = btn.closest('[data-ds-line]');
        const key = row.getAttribute('data-line-key');
        const qty = Number(row.getAttribute('data-line-qty') || 0) + 1;
        const cart = await changeLine(key, qty);
        renderCart(cart);
      });
    });
    bodyEl.querySelectorAll('[data-ds-qty-down]').forEach((btn) => {
      btn.addEventListener('click', async () => {
        const row = btn.closest('[data-ds-line]');
        const key = row.getAttribute('data-line-key');
        const qty = Math.max(0, Number(row.getAttribute('data-line-qty') || 0) - 1);
        const cart = await changeLine(key, qty);
        renderCart(cart);
      });
    });
    bodyEl.querySelectorAll('[data-ds-remove]').forEach((btn) => {
      btn.addEventListener('click', async () => {
        const row = btn.closest('[data-ds-line]');
        const key = row.getAttribute('data-line-key');
        const cart = await changeLine(key, 0);
        renderCart(cart);
      });
    });
    const checkout = bodyEl.querySelector('[data-ds-checkout]');
    if (checkout) {
      checkout.addEventListener('click', () => {
        window.location.href = '/checkout';
      });
    }
  }

  function updateBadge(count) {
    document.querySelectorAll('[data-ds-cart-count]').forEach((el) => {
      el.textContent = String(count);
      el.hidden = !count;
    });
  }

  async function refreshFromCart() {
    try {
      const cart = await fetchCart();
      renderCart(cart);
    } catch (err) {
      console.error(err);
    }
  }

  // Initial bind for SSR content
  if (bodyEl.querySelector('[data-ds-cart]:not([data-empty])')) {
    bindCartEvents();
  } else {
    bodyEl.querySelectorAll('[data-ds-drawer-close]').forEach((el) => {
      el.addEventListener('click', closeDrawer);
    });
  }

  document.addEventListener('hairplus:cart-updated', () => {
    refreshFromCart().then(openDrawer);
  });
})();
